import styled from 'styled-components'

interface Props {
  centered?: boolean
}

export const SectionInfo = styled.div`
  position: relative;
  margin-bottom: 2.5rem;
  text-align: ${(props: Props) => (props.centered ? 'center' : 'left')};
`
